module.exports = __webpack_public_path__ + "static/media/referral-code-hand.e3aeef22.png";